import * as React from 'react'
import { memo } from 'react'

import { ContributionMaterialType } from '../../store/contributions/contributionsTypings'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { addUrlToArray } from '../../store/common/commonSlice'
import { RootState } from '../../store/rootReducer'
import moment from 'moment-mini'
import useProtectImages from '../../hooks/useProtectImages'
import './styles.sass'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import paths from '../../paths'
import PremiumLogo from '../premiumLogo/PremiumLogo'
import { isUserPro } from '../../utils/isUserPro'

interface Props {
    material: ContributionMaterialType
    pro?: boolean
    isAgeVerified?: boolean
}

const ContributionMaterial: React.FunctionComponent<Props> = ({
    material,
    isAgeVerified = false,
    pro = false
}: Props) => {
    useProtectImages(null)
    const dispatch = useDispatch()
    const location = useLocation()

    const urlList = useSelector<RootState, string[]>((state) => state.common.backButton.urlList)

    const saveUrlForce = () => {
        if (!urlList.includes(location.pathname)) dispatch(addUrlToArray(location.pathname))
    }
    const { user } = useSelector((state: RootState) => state.member)

    const secondsInDay = 86400

    return (
        <Link className="contributionMaterial" to={isAgeVerified ? material.page_url : ''} onClick={saveUrlForce}>
            <div className={'contributionMaterialInfo'}>
                <div className={'materialInfo'}>{material.description}</div>
                <div className={'materialTags'}>
                    {/*{pro ? <PremiumLogo /> : <></>}*/}
                    {material.tags &&
                        material.tags
                            .filter((item, index) => index <= 4)
                            .map((item) => (
                                <a
                                    key={item.id}
                                    href={createLocalizedPath(paths.search.toPath({ tag: item.slug }))}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                    }}
                                >
                                    {item.text}
                                </a>
                            ))}
                </div>
            </div>
            <img
                src={material.thumbnail_url}
                alt={material.alt ? material.alt : ''}
                className={`${
                    (!user || !isUserPro(user.member_type)) && pro && !(user && user.id == material.user_id)
                        ? 'onlyForPro'
                        : ''
                } ${material.mime_type.includes('video') ? ' videoMaterial' : ''}`}
            />
            {material.mime_type.includes('video') && (
                <div className={'contributionVideoOverlay'}>
                    <img
                        src={require('../../assets/ic-play-black.svg')}
                        alt={material.alt ? material.alt : ''}
                        className={'contributionMaterialPlayButton'}
                    />
                    <div className={'contributionVideoDuration'}>
                        {material.duration &&
                            moment(material.duration * 1000).format(
                                material.duration > secondsInDay ? 'hh:mm:ss' : 'mm:ss'
                            )}
                    </div>
                </div>
            )}
        </Link>
    )
}

export default memo(ContributionMaterial)
